import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, formValueSelector } from 'redux-form';
import { Container, Button, Form } from 'reactstrap';
import { connect } from 'react-redux';
import Logger from 'util/Logger';
import { Band } from 'components/layout';
import TechnicianDetailsSection from './TechnicianDetailsSection';
import TechnicianSignatureSection from './TechnicianSignatureSection';
import { preventEnterSubmit } from 'actions/formActions';
import { useNavigate } from 'react-router-dom';

const propTypes = {
  handleSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  areas: PropTypes.array,
  signature: PropTypes.string
};

const TechnicianForm = (props) => {
  const { areas, handleSubmit, isSubmitting, signature } = props;

  const navigate = useNavigate(); // Use the useNavigate hook for navigation

  return (
    <Form onSubmit={handleSubmit} onKeyPress={preventEnterSubmit}>
      <Band tint>
        <TechnicianDetailsSection areas={areas} notificationareas={areas} />
      </Band>
      <Band tint>
        <TechnicianSignatureSection signature={signature} />
      </Band>
      <Container>
        <Button color="primary" className="btn-save" disabled={isSubmitting}>
          Save
        </Button>
      </Container>
    </Form>
  );
};

const selector = formValueSelector('technicianForm');

const mapStateToProps = (state) => ({
  areas: state.referenceData.areas,
  notificationAreas: state.referenceData.notificationareas,
  signature: selector(state, 'signature')
});

// Define onSubmitFail outside the component
const onSubmitFail = (errors) => {
  Logger.error(
    'We were unable to save the changes, please review the fields in red and try again.',
    errors,
    'Technician not saved'
  );
};

TechnicianForm.propTypes = propTypes;

const WrappedTechnicianForm = reduxForm({
  form: 'technicianForm',
  enableReinitialize: true,
  onSubmitFail // Pass the onSubmitFail function here
})(TechnicianForm);

export default connect(mapStateToProps)(WrappedTechnicianForm);
